import { gql } from '@apollo/client';

export const USER_COLLECTION_FRAGMENT = gql`
    fragment UserCollectionFragment on UserCollection {
        artworkUrl
        guid
        name
        sampleCount
        userId
    }
`;
